import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to determine if the current user owns a person profile
 */
export function useProfileOwnership() {
  const { user } = useAuth();
  const [currentUserProfileId, setCurrentUserProfileId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentUserProfile = async () => {
      if (!user) {
        setCurrentUserProfileId(null);
        setLoading(false);
        return;
      }

      try {
        const { data: profile, error } = await supabase
          .from('profiles')
          .select('id')
          .eq('user_id', user.id)
          .single();

        if (error) {
          console.error('Error fetching user profile:', error);
          setCurrentUserProfileId(null);
        } else {
          setCurrentUserProfileId(profile?.id || null);
        }
      } catch (error) {
        console.error('Error in fetchCurrentUserProfile:', error);
        setCurrentUserProfileId(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUserProfile();
  }, [user]);

  const isProfileOwner = (profileId: string | null | undefined): boolean => {
    if (!profileId || !currentUserProfileId) return false;
    return currentUserProfileId === profileId;
  };

  return {
    currentUserProfileId,
    isProfileOwner,
    loading
  };
}